/*
 * A care item the nurse enabled for an SOS arrives with no action rows, so
 * there is no action id for the SOS table to save against. One placeholder
 * row is stood in for it (see CareItemTabs) carrying a key instead of an id,
 * and what the SOS endpoint needs to create the first action is kept here
 * against that key.
 *
 * It lives in a module rather than being threaded through props because the
 * row passes through every care item component on its way to SosTable, and
 * each one forwards only the action id.
 */
const contexts = new Map();

export const SOS_PLACEHOLDER_PREFIX = "sos-placeholder:";

export const makeSosPlaceholderKey = (enabledCareItemId) =>
  `${SOS_PLACEHOLDER_PREFIX}${enabledCareItemId}`;

export const isSosPlaceholderKey = (key) =>
  typeof key === "string" && key.startsWith(SOS_PLACEHOLDER_PREFIX);

export const registerSosPlaceholder = (key, context) => {
  contexts.set(key, context);
};

export const getSosPlaceholder = (key) =>
  isSosPlaceholderKey(key) ? contexts.get(key) : undefined;
